// extracted by mini-css-extract-plugin
export default {"container":"container---TSXZz","footerContent":"footerContent---fDHt4"};